<template>
  <SkeletonPulse>
    <div class="vacancy-card-skeleton">
      <div class="vacancy-card-skeleton__mobile-date mq-mobile-only">
        <SkeletonShape width="62px" height="8px" />
      </div>
      <div class="vacancy-card-skeleton__aside">
        <SkeletonShape width="50px" height="50px" />
      </div>
      <div class="vacancy-card-skeleton__main">
        <div class="vacancy-card-skeleton__date mq-not-mobile">
          <SkeletonShape width="82px" height="12px" />
        </div>
        <div class="vacancy-card-skeleton__content mq-not-mobile">
          <SkeletonShape width="283px" height="16px" />
          <SkeletonShape width="69px"  height="12px" />
          <SkeletonShape width="431px" height="12px" />
          <SkeletonShape width="431px" height="12px" />
          <SkeletonShape width="431px" height="12px" />
          <SkeletonShape width="431px" height="12px" />
        </div>
        <div class="vacancy-card-skeleton__mobile-content mq-mobile-only">
          <SkeletonShape width="275px" height="12px" />
          <SkeletonShape width="225px" height="12px" />
          <SkeletonShape width="132px" height="8px" />
          <SkeletonShape width="275px" height="8px" />
          <SkeletonShape width="275px" height="8px" />
          <SkeletonShape width="275px" height="8px" />
        </div>
      </div>
    </div>
  </SkeletonPulse>
</template>

<script>
  import SkeletonPulse from "src/components/SkeletonPulse/SkeletonPulse.vue";
  import SkeletonShape from "src/components/SkeletonShape/SkeletonShape.vue";

  export default {
    name: 'VacancyCardSkeleton',
    components: { SkeletonPulse, SkeletonShape },
  }
</script>